import { render, staticRenderFns } from "./couponDialog.vue?vue&type=template&id=1fa93594&scoped=true"
import script from "./couponDialog.vue?vue&type=script&lang=js"
export * from "./couponDialog.vue?vue&type=script&lang=js"
import style0 from "./couponDialog.vue?vue&type=style&index=0&id=1fa93594&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa93594",
  null
  
)

export default component.exports